import { useI18n }            from '../../../../shared/i18n/useI18n.js';
import { useProductStrings }  from '../../../../shared/i18n/useProductStrings.js';

import { Button }             from '../../../../shared/ui/Button/Button.jsx';
import { HeartButton }        from '../../../../shared/ui/HeartButton/HeartButton.jsx';
import { Plan }               from '../../../../shared/ui/icons/Plan.jsx';
import { Tooltip }            from '../../../../shared/ui/Tooltip/Tooltip.jsx';

export function FloorPlanAction({ 
  product,
  context
}) {
  const { t } = useI18n();
  const getProductsCategoryString = useProductStrings();

  const {
    buttonClass,
    size="medium",
    variant="ghost",
    cta = false,
    onProductClick
  } = context;

  const idOriginal =
    product?.id_original ?? product.cms_product_name ?? product?.id_cad ?? null;

  return (
    <Tooltip
      title={`${getProductsCategoryString('open', product.product_category, { id: idOriginal })}`}
      placement="top"
      disableOnMobile
    >
      <Button
        type="button"
        size={size}
        variant={variant}
        cta={cta}
        onClick={(e) => {
          e.stopPropagation();
          onProductClick(product);
        }}
        onTouchEnd={(e) => e.stopPropagation()}
        aria-label={t('catalog.open_unit', { id: idOriginal })}
      >
        <Plan />
      </Button>
    </Tooltip>
  );
}